var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKundenlogoXing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 61,
    viewBox: "0 0 122 61",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#335466",
    x: 0.5,
    y: 0.5,
    width: 121,
    height: 60,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#335466"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.429 21.147 3.236 5.915-4.838 8.725h5.767l4.806-8.725-3.236-5.915h-5.735M32.329 16.267l-9.556 16.63 6.162 11.023h5.997l-6.26-11.022 9.555-16.631h-5.898M77.761 18.991h-3.975v22.204h4.59v-12.56l7.561 12.56h3.846V18.991h-4.59v12.56l-7.432-12.56zm31.226 9.457h-7.797v3.833h3.48v4.823a6.04 6.04 0 0 1-2.352.447c-3.576 0-5.058-2.65-5.058-7.378 0-4.408 1.288-7.602 5.51-7.602 1.417 0 2.963.384 4.477 1.054l1.353-3.545c-1.868-.958-3.898-1.373-6.025-1.373-6.926 0-9.986 4.311-9.986 11.434 0 7.282 2.931 11.339 9.73 11.339 2.19 0 4.413-.447 6.668-1.501v-11.53zM65.008 41.195h4.719V18.991h-4.719v22.204zm-14.91-22.204 3.393 7.081 3.716-7.08h4.848L56.11 29.628l6.172 11.566h-5.074l-3.813-7.753-3.78 7.753h-4.88l5.88-11.502-5.622-10.702h5.106z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKundenlogoXing);
export default __webpack_public_path__ + "static/media/kundenlogo-xing.b2b865e67f646d9a3d1ff879ce18d8f1.svg";
export { ForwardRef as ReactComponent };